import { axiosClient } from "./axiosClient";
import { ZkMaterial, ZkProofBundle } from "../utils/zkVote";

// Enrollment + materiał do dowodu. Wysyła SAM commitment (nie sekret). Wpis do drzewa elektoratu
// jest bramkowany istniejącą autoryzacją po stronie serwera (token/konto/Aura). Idempotentne.
// Zwraca ścieżkę Merkle + root + epoch — wszystko publiczne, nie zdradza sekretu.
export const getZkVoteMaterial = async (votingId: string, commitment: string, voterEmail?: string, cyberidAssertion?: string) => {
  try {
    return await axiosClient.post<ZkMaterial>(`votings/${votingId}/zk_material`, {
      commitment,
      voter_email: voterEmail,
      cyberid_assertion: cyberidAssertion
    });
  } catch (err: any) {
    console.error(err);
    return err?.response;
  }
};

// Relayer: przekazuje dowód do węzła. Backend NIE jest autorem transakcji — tylko przekazuje
// (głos to jedyna transakcja bez podpisu; autoryzacją jest dowód ZKP + nullifier).
export const submitZkVote = async (votingId: string, bundle: ZkProofBundle, voterEmail?: string) => {
  try {
    return await axiosClient.post(`votings/${votingId}/zk_vote`, {
      proof: bundle.proof,
      public: bundle.publicSignals,
      voter_email: voterEmail
    });
  } catch (err: any) {
    console.error(err);
    return err?.response;
  }
};
